import * as ng from 'angular';
import * as Linq from 'linq-es5';
import {ComponentRegistration, ISiteConfigService} from '../../core';
import {Moment} from 'moment';
import {ICustomerSettingsService, ISessionService} from '../../services';
import {IAccountRequestResource} from './data/account-request'
import {IUserResource} from '../security';
import {Dto} from '../../data';
import {ContentTypeSettingKeys, IParkingMediaRequest} from '../../data/interfaces';
import {IContentTemplateResource} from '../../data/content-template'
import {CreditCardControlState} from "../../user-controls/credit-card-control-state";

let template = require('./account-request.html');
let wizardTemplate = require('./user-controls/wizard-template.html');
let wizardStepTemplate = require('./user-controls/wizard-step-template.html');
let accountRequestTerms = require('./account-request-terms.html');

class AccountRequestComponent extends ComponentRegistration {

    constructor() {
        super('accountRequest', {
            controller: AccountRequestController,
            templateUrl: template,
            controllerAs: 'account',
            bindings: {
            }
        });
    }
}

interface IAccountRequestController {
    activate(): void;
    onCancelClick(): void;
    onUsernameChanged(): void;
    calculateTotal(): void;
    onAccountNext(): void;
    onNext(): void;
    onFinish(): any;
    checkUsernameInUse(): void;
    saveAccountRequest(): void;
    sendScreenUpdatesToWizard(screenInfo, stepIcons): void;
    assureWizardRef(screenInfo, stepIcons): void;
    onCreditCardTokenReceived(creditCard): void;
    onChange(): any;
    showTerms(ev, msg): void;
    getParkingMediaRequestsToSend() : IParkingMediaRequest[];
}

class AccountRequestController implements IAccountRequestController {
    private static $inject: Array<string> = ['$rootRouter', '$window', '$scope', '$mdMedia', 'Session', 'WizardHandler', 'AccountRequest', 'User', '$timeout', '$mdDialog', 'SiteConfig', 'moment', 'CustomerSettings', 'ContentTemplate'];

    public wizardTemplateUrl: string = wizardTemplate;
    public wizardStepTemplateUrl: string = wizardStepTemplate;
    public accountRequestTermsUrl: string = accountRequestTerms;

    private wizard = null;
    private preferredParkingArea: any = {};
    private alternateParkingArea: any = {};
    private userNameUserModified: Boolean = false;
    private reachedReviewPage: Boolean = false;
    private usernameExists: Boolean = false;
    private customFullscreen = this.$mdMedia('xs') || this.$mdMedia('sm');
    private useFullScreen = (this.$mdMedia('sm') || this.$mdMedia('xs')) && this.customFullscreen;
    private reservedParkingEnabled: Boolean = true;
    private totalCost: number = 0;
    private userForm: any;
    private fppSettings: Dto.IFrequentParkerSettings;
    private generalSettings: Dto.IGeneralSettings;
    private hasFrequentParkerNumber: boolean = false;
    private key: string = ContentTypeSettingKeys[ContentTypeSettingKeys.Terms];
    private language: string = 'en';
    private terms: string;
    private creditCardControlState: CreditCardControlState = CreditCardControlState.ReCaptchaValidation;
    private types: any = {
        Personal: "Personal",
        Business: "Business"
    };

    private request: Dto.IAccountRequest = {
        accountType: this.types.Personal,
        name: "",
        address1: "",
        address2: "",
        city: "",
        country: "",
        subdivision: "",
        postalCode: "",
        firstName: "",
        lastName: "",
        email: "",
        homePhone: "",
        mobilePhone: "",
        workPhone: "",
        fax: "",
        language: "",
        username: "",
        password: "",
        confirm: "",
        securityQuestionId: "",
        securityAnswer: "",
        preferredParkingAreaId: "",

        alternateParkingAreaId: "",
        requestDateTime: (this.moment as any)().format(),
        isReserveParkingRequest: true,
        isFrequentParkerRequest: true,

        creditCardType: "",
        expirationMonth: "",
        expirationYear: "",

        maskedCreditCard: "",
        token: "",
        parkingMediaRequests: [
        ]
    } as Dto.IAccountRequest;

    constructor(private $router: ng.Router,
        private $window: ng.IWindowService,
        private $scope: ng.IScope,
        private $mdMedia: ng.material.IMedia,
        private Session: ISessionService,
        private WizardHandler: ng.mgoAngularWizard.WizardHandler,
        private AccountRequest: IAccountRequestResource,
        private User: IUserResource,
        private $timeout: ng.ITimeoutService,
        private $mdDialog: ng.material.IMedia,
        private SiteConfig: ISiteConfigService,
        private moment: Moment,
        private CustomerSettings: ICustomerSettingsService,
        private ContentTemplate: IContentTemplateResource) {

        this.activate();

    }

    public activate(): void {
        console.log("AccountRequest controller loaded.");
        this.CustomerSettings.getFrequentParkerSettings()
            .then((response) => {
                this.fppSettings = response.settings;
                this.request.isFrequentParkerRequest = this.fppSettings.enabled;
            });

        this.CustomerSettings.getReservedParkingSettings()
            .then((response) => {
                this.reservedParkingEnabled = response.enabled;
                this.request.isReserveParkingRequest = response.enabled;
            });

        this.CustomerSettings.getGeneralSettings()
            .then((response) => {
                this.generalSettings = response.settings;
            });

        this.ContentTemplate.query({ key: this.key, languageCode: this.language }).$promise
            .then((response) => {
                let template = Linq.From(response).FirstOrDefault();
                this.terms = template.content;
            });    

        this.wizard = this.WizardHandler.wizard();

        var w = ng.element(this.$window);
        w.bind('resize', () => {
            this.$scope.$apply();
        });

        var stepIcons = {
            'Account': 'account_balance',
            'User': 'verified_user',
            'Payment': 'payment',
            'Review & Submit': 'receipt',
            'Parking Area & Media': 'local_parking'

        };

        this.$scope.$watch(() => {
            return this.$window.innerWidth;
        }, (value) => {
            var screenInfo = {
                innerWidth: value,
                'sm': this.$mdMedia('sm'),
                'xs': this.$mdMedia('xs'),
                'gt-sm': this.$mdMedia('gt-sm'),
                'lg': this.$mdMedia('gt-sm')
            };

            this.wizard = this.WizardHandler.wizard();
            if (this.wizard) {
                this.sendScreenUpdatesToWizard(screenInfo, stepIcons);
            }
            else {
                this.assureWizardRef(screenInfo, stepIcons);
            }
        });
        let self = this;
        this.$scope.$watch("account.request.parkingMediaRequests", () => { self.calculateTotal() }, true);
        this.$scope.$watch("account.preferredParkingArea", () => { self.calculateTotal() });
        this.$scope.$watch("account.alternateParkingArea", () => { self.calculateTotal() });

        console.log("AccountRequest controller activated.");
    }

    public onCancelClick(): void {
        this.$router.navigate(['Home']);
    }

    public onUsernameChanged(): void {
        this.userNameUserModified = true;
        if (this.userForm.username.$valid)
            this.checkUsernameInUse();
        else {
            this.usernameExists = false;
        }
    }

    public calculateTotal(): void {

        var mediaList = Linq.from(this.request.parkingMediaRequests);
        this.totalCost = mediaList.Sum((x: any) => { return x.type.price * x.quantity; });

        if (this.preferredParkingArea && this.preferredParkingArea.spacesAvailable) {
            this.totalCost += this.preferredParkingArea.membershipCost;
        }
        else if (this.alternateParkingArea && this.alternateParkingArea.spacesAvailable) {
            this.totalCost += this.alternateParkingArea.membershipCost;
        }
    }

    public getParkingMediaRequestsToSend() : IParkingMediaRequest[] {
        return Linq.from(this.request.parkingMediaRequests).Where((x: any) => { return x.quantity > 0 }).ToArray();
    }

    public onAccountNext(): void {
        if (this.request.username == "" && !this.userNameUserModified) {
            this.request.username = this.request.email;
            this.checkUsernameInUse();
        }

        this.onNext();
    }

    public onNext(): void {
        if (!this.reachedReviewPage) {
            this.reachedReviewPage =
                "Review & Submit" === this.wizard.currentStepTitle();
        }

        this.creditCardControlState = CreditCardControlState.ReCaptchaValidation;
    }

    public onFinish(): any {
        this.saveAccountRequest();
        var temp = this;
        return;
    }

    public checkUsernameInUse(): void {

        this.User.userExists({ username: this.request.username }).$promise
            .then((response) => {
                this.usernameExists = (response as any).exists === "true";
            });

    }

    public saveAccountRequest(): void {
        var request = ng.copy(this.request);
        request.parkingMediaRequests = Linq.from(request.parkingMediaRequests)
            .Where((x: any) => { return x.quantity > 0 }).ToArray();

        request.requestDateTime = (this.moment as any)().format();

        this.Session.getLanguage().then((language) => {
            request.language = language.code;
            this.AccountRequest.insert({}, request).$promise
                .then((response) => {
                    this.$router.navigate(['AccountRequestCompleted']);
                })
                .catch((e) => {
                    console.debug(e);
                });
        });


    }

    public sendScreenUpdatesToWizard(screenInfo, stepIcons): void {
        this.wizard.context.screenInfo = screenInfo;
        this.wizard.context.stepIcons = stepIcons;
    }

    public assureWizardRef(screenInfo, stepIcons): void {
        if (this.wizard) {
            this.sendScreenUpdatesToWizard(screenInfo, stepIcons);
            this.$scope.$apply();
        }
        else {
            setTimeout(() => {
                this.wizard = this.WizardHandler.wizard();
                this.assureWizardRef(screenInfo, stepIcons);
            }, 200);
        }
    }

    public onCreditCardTokenReceived(creditCard: Dto.ICreditCard): void {
        this.request.creditCardType = creditCard.creditCardType;
        this.request.expirationMonth = creditCard.expirationMonth
        this.request.expirationYear = creditCard.expirationYear;
        this.request.maskedCreditCard = creditCard.maskedCreditCard;
        this.request.token = creditCard.token;

        if (this.wizard) {
            this.wizard.next();
            setTimeout(() => {
                this.onNext();
            }, 300);

        }
        else {
            throw "Wizard reference was unexpectantly null."
        }
    }

    public onCreditCardTokenCancelled() {
        if (this.wizard) {
            this.wizard.previous();
        }
    }

    public onChange(): any {

        return;
    }
    //TODO: $mdDialog as any.show       'app/components/public/account-request-terms.html'
    public showTerms(ev, msg): void {
        this.useFullScreen = (this.$mdMedia('sm') || this.$mdMedia('xs')) && this.customFullscreen;
        (this.$mdDialog as any).show({
            controller: ['$scope', '$mdDialog', ($scope, $mdDialog) => {
                $scope.terms = this.terms;
                $scope.cancel = () => {
                    $mdDialog.cancel();
                };
            }],
            templateUrl: this.accountRequestTermsUrl,
            parent: ng.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: this.useFullScreen
        });
        this.$scope.$watch(() => {
            return this.$mdMedia('xs') || this.$mdMedia('sm');
        }, (wantsFullScreen) => {
            this.customFullscreen = (wantsFullScreen === true);
        });
    };
}

let acctreqComponent = new AccountRequestComponent();
export default acctreqComponent;
export { acctreqComponent as AccountRequestComponent, IAccountRequestController, AccountRequestController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/public/account-request.ts